import React from 'react';
import Link from '@material-ui/core/Link';
import Container from '@material-ui/core/Container';
import ConfirmationNumberOutlinedIcon from '@material-ui/icons/ConfirmationNumberOutlined';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';

class RestoreConfirmation extends React.Component  {

    render() {

        return (
            <Container component="main" maxWidth="xs">
                <div className={this.props.classes.paper}>
                    <Avatar className={this.props.classes.avatar}>
                        <ConfirmationNumberOutlinedIcon/>
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Восстановление пароля
                    </Typography>
                    <br/>
                    <p>Вам на почту было выслано сообщение с описанием дальнейших действий для восстановления пароля на сайте <Link href="https://www.alaber.ru">www.alaber.ru</Link>.</p>
                    <p textAlign='left'>Пожалуйста, проверьте почту.</p>
                    <p>После восстановления пароля Вы сможете войти в личный кабинет.</p>
                    <br/>
                    <Link href="./" variant="body2">
                        Вход в портал
                    </Link>
                </div>
            </Container>
    )

    }

}

export default RestoreConfirmation;